/* ==========================================================================
   RELOA — Motion & conversion engine
   Vanilla JS. Config injected via window.RELOA (layout/theme.liquid)
   ========================================================================== */
(function () {
  'use strict';

  var CFG = window.RELOA || {};
  var S = CFG.strings || {};
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var motionLevel = CFG.motion || 'cinematic';
  var motionOff = reduceMotion || motionLevel === 'off';
  var isFine = window.matchMedia('(pointer: fine)').matches;
  var isTouch = !isFine || 'ontouchstart' in window;

  /* ---------- utils ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts || false); }
  function clamp(n, min, max) { return Math.min(max, Math.max(min, n)); }
  function formatMoney(cents) {
    var val = (cents / 100).toFixed(2);
    var fmt = CFG.moneyFormat || '₹{{amount}}';
    if (fmt.indexOf('{{amount_with_commas}}') > -1) {
      return fmt.replace('{{amount_with_commas}}', Number(val).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
    }
    if (fmt.indexOf('{{amount_no_decimals}}') > -1) {
      return fmt.replace('{{amount_no_decimals}}', Math.round(cents / 100).toLocaleString('en-IN'));
    }
    return fmt.replace('{{amount}}', Number(val).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
  }
  function store(key, val) {
    try {
      if (typeof val === 'undefined') {
        var raw = window.sessionStorage.getItem(key);
        return raw ? JSON.parse(raw) : null;
      }
      window.sessionStorage.setItem(key, JSON.stringify(val));
    } catch (e) { return null; }
  }
  function seeded(seed) {
    var x = Math.sin(seed) * 10000;
    return x - Math.floor(x);
  }

  /* ---------- body lock ---------- */
  var lockCount = 0;
  function lockBody() {
    lockCount++;
    document.body.style.overflow = 'hidden';
  }
  function unlockBody() {
    lockCount = Math.max(0, lockCount - 1);
    if (lockCount === 0) document.body.style.overflow = '';
  }

  /* ---------- overlay ---------- */
  var overlay = $('[data-overlay]');
  function showOverlay() { if (overlay) { overlay.hidden = false; requestAnimationFrame(function () { overlay.classList.add('is-visible'); }); } }
  function hideOverlay() {
    if (overlay) {
      overlay.classList.remove('is-visible');
      setTimeout(function () { overlay.hidden = true; }, 400);
    }
  }

  /* ---------- toast ---------- */
  function toast(message, isError) {
    var holder = $('[data-toast-holder]');
    if (!holder) {
      holder = document.createElement('div');
      holder.setAttribute('data-toast-holder', '');
      holder.style.cssText = 'position:fixed;top:18px;left:50%;transform:translateX(-50%);z-index:210;display:grid;gap:8px;width:min(420px,92vw);';
      document.body.appendChild(holder);
    }
    var t = document.createElement('div');
    t.textContent = message;
    t.style.cssText = 'background:' + (isError ? '#B3261E' : '#2A1520') + ';color:#F9EDE9;padding:14px 22px;border-radius:14px;font-size:0.9rem;box-shadow:0 18px 40px -14px rgba(42,21,32,0.5);opacity:0;transform:translateY(-12px);transition:all .4s cubic-bezier(.22,.8,.26,.99);text-align:center;';
    holder.appendChild(t);
    requestAnimationFrame(function () { t.style.opacity = '1'; t.style.transform = 'translateY(0)'; });
    setTimeout(function () {
      t.style.opacity = '0';
      t.style.transform = 'translateY(-12px)';
      setTimeout(function () { t.remove(); }, 450);
    }, 2600);
  }

  /* ---------- custom cursor ---------- */
  function initCursor() {
    if (!CFG.cursor || !isFine || motionOff) return;
    var cursor = $('.reloa-cursor');
    if (!cursor) return;
    var dot = $('.reloa-cursor__dot', cursor);
    var ring = $('.reloa-cursor__ring', cursor);
    var x = -100, y = -100, rx = -100, ry = -100, raf;
    document.addEventListener('mousemove', function (e) {
      x = e.clientX; y = e.clientY;
      dot.style.transform = 'translate(' + x + 'px,' + y + 'px) translate(-50%,-50%)';
    });
    (function loop() {
      rx += (x - rx) * 0.16;
      ry += (y - ry) * 0.16;
      ring.style.transform = 'translate(' + rx + 'px,' + ry + 'px) translate(-50%,-50%)';
      raf = requestAnimationFrame(loop);
    })();
    var HOVER = 'a, button, input, select, textarea, label, summary, [data-tilt], [data-magnetic]';
    document.addEventListener('mouseover', function (e) {
      if (e.target.closest(HOVER)) document.body.classList.add('cursor-hover');
    });
    document.addEventListener('mouseout', function (e) {
      if (e.target.closest(HOVER)) document.body.classList.remove('cursor-hover');
    });
    document.addEventListener('mousedown', function () { document.body.classList.add('cursor-press'); });
    document.addEventListener('mouseup', function () { document.body.classList.remove('cursor-press'); });
    document.addEventListener('mouseleave', function () { cursor.style.opacity = '0'; });
    document.addEventListener('mouseenter', function () { cursor.style.opacity = '1'; });
  }

  /* ---------- reveal on scroll ---------- */
  function initReveals() {
    var els = $$('[data-reveal]:not(.in-view)');
    if (!els.length) return;
    if (motionOff || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in-view'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var delay = entry.target.getAttribute('data-reveal-delay');
          if (delay) entry.target.style.setProperty('--d', (parseFloat(delay) * 0.08) + 's');
          entry.target.classList.add('in-view');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- 3D tilt + glare ---------- */
  function initTilt() {
    if (!isFine || motionOff || motionLevel !== 'cinematic') return;
    $$('[data-tilt]').forEach(function (el) {
      if (el.__tiltBound) return;
      el.__tiltBound = true;
      var glareHolder = el.querySelector('.product-card__media');
      if (glareHolder && !glareHolder.querySelector('.product-card__glare')) {
        var g = document.createElement('span');
        g.className = 'product-card__glare';
        glareHolder.appendChild(g);
      }
      var max = 7;
      el.addEventListener('mousemove', function (e) {
        var r = el.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width;
        var py = (e.clientY - r.top) / r.height;
        var rX = (0.5 - py) * max;
        var rY = (px - 0.5) * max;
        el.style.transform = 'perspective(900px) rotateX(' + rX.toFixed(2) + 'deg) rotateY(' + rY.toFixed(2) + 'deg) translateY(-3px)';
        var media = el.querySelector('.product-card__media');
        if (media) {
          media.style.setProperty('--gx', (px * 100).toFixed(1) + '%');
          media.style.setProperty('--gy', (py * 100).toFixed(1) + '%');
        }
      });
      el.addEventListener('mouseleave', function () {
        el.style.transform = 'perspective(900px) rotateX(0) rotateY(0) translateY(0)';
      });
    });
  }

  /* ---------- magnetic buttons ---------- */
  function initMagnetic() {
    if (!isFine || motionOff || motionLevel !== 'cinematic') return;
    $$('[data-magnetic]').forEach(function (el) {
      if (el.__magBound) return;
      el.__magBound = true;
      el.addEventListener('mousemove', function (e) {
        var r = el.getBoundingClientRect();
        var mx = (e.clientX - r.left - r.width / 2) * 0.22;
        var my = (e.clientY - r.top - r.height / 2) * 0.3;
        el.style.transform = 'translate(' + mx.toFixed(1) + 'px,' + my.toFixed(1) + 'px)';
      });
      el.addEventListener('mouseleave', function () {
        el.style.transform = 'translate(0,0)';
      });
    });
  }

  /* ---------- hero mouse parallax ---------- */
  function initHeroParallax() {
    if (isTouch || motionOff || motionLevel !== 'cinematic') return;
    var hero = $('[data-hero]');
    if (!hero) return;
    var layers = $$('[data-parallax]', hero).concat($$('[data-orb]', hero));
    if (!layers.length) return;
    hero.addEventListener('mousemove', function (e) {
      var r = hero.getBoundingClientRect();
      var mx = (e.clientX - r.left) / r.width - 0.5;
      var my = (e.clientY - r.top) / r.height - 0.5;
      layers.forEach(function (layer) {
        var depth = parseFloat(layer.getAttribute('data-depth') || '20');
        layer.style.translate = (mx * depth) + 'px ' + (my * depth) + 'px';
      });
      var scene = $('[data-hero-scene]', hero);
      if (scene) {
        scene.style.transform = 'rotateY(' + (mx * 4).toFixed(2) + 'deg) rotateX(' + (-my * 3).toFixed(2) + 'deg)';
      }
    });
    hero.addEventListener('mouseleave', function () {
      layers.forEach(function (layer) { layer.style.translate = '0px 0px'; });
      var scene = $('[data-hero-scene]', hero);
      if (scene) scene.style.transform = 'rotateY(0) rotateX(0)';
    });
  }

  /* ---------- scroll parallax (subtle depth on images) ---------- */
  function initScrollParallax() {
    if (motionOff || motionLevel !== 'cinematic') return;
    var els = $$('[data-parallax-y]');
    if (!els.length) return;
    function update() {
      var vh = window.innerHeight;
      els.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var strength = parseFloat(el.getAttribute('data-strength') || '0.08');
        var offset = ((r.top + r.height / 2) - vh / 2) * -strength;
        el.style.transform = 'translateY(' + offset.toFixed(1) + 'px)';
      });
    }
    window.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
    update();
  }

  /* ---------- word rotator ---------- */
  function initRotator() {
    var rotators = $$('[data-rotator]');
    rotators.forEach(function (rot) {
      var words = $$('[data-word]', rot);
      if (words.length < 2 || motionOff) return;
      var i = 0;
      setInterval(function () {
        var current = words[i];
        current.classList.remove('is-active');
        current.classList.add('is-leaving');
        (function (leaving) {
          setTimeout(function () { leaving.classList.remove('is-leaving'); }, 600);
        })(current);
        i = (i + 1) % words.length;
        words[i].classList.add('is-active');
      }, 3200);
    });
  }

  /* ---------- count-up numbers ---------- */
  function initCountUps() {
    var els = $$('[data-count-to]');
    if (!els.length) return;
    var fmtNum = function (n, dec) {
      if (dec > 0) return n.toFixed(dec);
      return Math.round(n).toLocaleString('en-IN');
    };
    var animate = function (el) {
      var raw = parseFloat(el.getAttribute('data-count-to'));
      if (isNaN(raw)) return;
      var original = el.textContent;
      var suffix = original.replace(/^[\d.,]+/, '');
      var dec = (el.getAttribute('data-count-to').indexOf('.') > -1) ? 1 : 0;
      if (motionOff) { el.textContent = fmtNum(raw, dec) + suffix; return; }
      var start = null, dur = 1600;
      function step(ts) {
        if (!start) start = ts;
        var p = clamp((ts - start) / dur, 0, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = fmtNum(raw * eased, dec) + suffix;
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    };
    if (!('IntersectionObserver' in window)) { els.forEach(animate); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { animate(entry.target); io.unobserve(entry.target); }
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- announcement rotator ---------- */
  function initAnnouncement() {
    var bar = $('[data-announcement]');
    if (!bar) return;
    var slides = $$('[data-slide]', bar);
    var dots = $$('[data-dot]', bar);
    if (slides.length < 2) return;
    var i = 0;
    setInterval(function () {
      slides[i].classList.remove('is-active');
      if (dots[i]) dots[i].classList.remove('is-active');
      i = (i + 1) % slides.length;
      slides[i].classList.add('is-active');
      if (dots[i]) dots[i].classList.add('is-active');
    }, 5000);
    dots.forEach(function (dot) {
      on(dot, 'click', function () {
        var idx = parseInt(dot.getAttribute('data-dot'), 10);
        slides[i].classList.remove('is-active');
        if (dots[i]) dots[i].classList.remove('is-active');
        i = idx;
        slides[i].classList.add('is-active');
        dot.classList.add('is-active');
      });
    });
  }

  /* ---------- header behavior ---------- */
  function initHeader() {
    var header = $('[data-header]');
    if (!header) return;
    var lastY = 0;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      if (y > 24) header.classList.add('is-scrolled');
      else header.classList.remove('is-scrolled');
      if (y > 320 && y > lastY + 6) header.classList.add('is-hidden');
      else if (y < lastY - 6 || y < 320) header.classList.remove('is-hidden');
      lastY = y;
    }, { passive: true });
  }

  /* ---------- drawers & modals ---------- */
  function closeMobileDrawer() {
    var d = $('[data-mobile-drawer]');
    if (d && d.classList.contains('is-open')) {
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
      unlockBody();
      hideOverlay();
    }
  }
  function initDrawers() {
    var burger = $('[data-burger]');
    var drawer = $('[data-mobile-drawer]');
    on(burger, 'click', function () {
      if (!drawer) return;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      burger.setAttribute('aria-expanded', 'true');
      lockBody();
      showOverlay();
    });
    var closeBtn = $('[data-drawer-close]');
    on(closeBtn, 'click', closeMobileDrawer);
    $$('.mobile-drawer a').forEach(function (a) { on(a, 'click', closeMobileDrawer); });

    var searchModal = $('[data-search-modal]');
    function openSearch() {
      if (!searchModal) return;
      searchModal.classList.add('is-open');
      searchModal.setAttribute('aria-hidden', 'false');
      lockBody();
      var input = $('[data-search-input]', searchModal);
      setTimeout(function () { if (input) input.focus(); }, 120);
    }
    function closeSearch() {
      if (!searchModal) return;
      searchModal.classList.remove('is-open');
      searchModal.setAttribute('aria-hidden', 'true');
      unlockBody();
    }
    on($('[data-search-open]'), 'click', openSearch);
    on($('[data-search-close]'), 'click', closeSearch);
    window.__closeSearch = closeSearch;

    on(document, 'keydown', function (e) {
      if (e.key === 'Escape') {
        closeMobileDrawer();
        closeSearch();
        closeCart();
        closeExit();
      }
    });
    on(overlay, 'click', function () {
      closeMobileDrawer();
      closeCart();
    });
  }

  /* ---------- cart drawer core ---------- */
  var cartDrawer = null;
  function openCart() {
    if (!CFG.cartDrawer) { window.location.href = CFG.routes.cart; return; }
    if (!cartDrawer) cartDrawer = $('[data-cart-drawer]');
    if (!cartDrawer) { window.location.href = CFG.routes.cart; return; }
    closeMobileDrawer();
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    lockBody();
    showOverlay();
  }
  function closeCart() {
    if (!cartDrawer) cartDrawer = $('[data-cart-drawer]');
    if (cartDrawer && cartDrawer.classList.contains('is-open')) {
      cartDrawer.classList.remove('is-open');
      cartDrawer.setAttribute('aria-hidden', 'true');
      unlockBody();
      hideOverlay();
    }
  }

  function updateCountBadge(count) {
    $$('[data-cart-count]').forEach(function (badge) {
      badge.textContent = count;
      badge.classList.toggle('is-empty', count === 0);
      badge.classList.add('bump');
      // Hide bubble-style badges (e.g. mobile nav) when cart is empty
      if (badge.classList.contains('mobile-nav__cart-bubble')) {
        badge.hidden = count === 0;
      } else {
        badge.hidden = false;
      }
      setTimeout(function () { badge.classList.remove('bump'); }, 400);
    });
    $$('[data-drawer-count]').forEach(function (el) {
      el.textContent = '(' + count + ')';
    });
  }

  function updateFreeShip(total) {
    var threshold = CFG.freeShipThreshold || 0;
    if (!threshold) return;
    $$('[data-freeship]').forEach(function (widget) {
      var fill = $('[data-freeship-fill]', widget);
      var label = $('[data-freeship-label]', widget);
      if (!fill) return;
      var pct = clamp((total / threshold) * 100, 0, 100);
      fill.style.width = pct + '%';
      if (label) {
        if (total >= threshold) {
          label.innerHTML = 'You&rsquo;ve unlocked <strong>FREE shipping</strong>';
        } else {
          var remaining = formatMoney(threshold - total);
          label.innerHTML = 'You&rsquo;re <strong>' + remaining + '</strong> away from <strong>FREE shipping</strong>';
        }
      }
    });
  }

  function refreshCart(openAfter) {
    var headers = { 'Cache-Control': 'no-cache' };
    fetch(CFG.routes.cart + '?sections=cart-drawer', { headers: headers })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data && data['cart-drawer'];
        if (!html) return;
        var holder = document.getElementById('shopify-section-cart-drawer');
        if (!holder) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('.cart-drawer');
        var current = $('[data-cart-drawer]');
        if (fresh && current) {
          var wasOpen = current.classList.contains('is-open');
          current.innerHTML = fresh.innerHTML;
          if (wasOpen) current.classList.add('is-open');
        }
      })
      .catch(function () {})
      .then(function () {
        return fetch(CFG.routes.cart + '.js', { headers: headers });
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart) return;
        updateCountBadge(cart.item_count);
        updateFreeShip(cart.total_price);
        $$('[data-cart-subtotal]').forEach(function (el) { el.textContent = formatMoney(cart.total_price); });
        if (openAfter) openCart();
        document.dispatchEvent(new CustomEvent('reloa:cart-updated', { detail: cart }));
      })
      .catch(function () {});
  }

  function initCartInteractions() {
    on(document, 'click', function (e) {
      var openBtn = e.target.closest('[data-cart-open]');
      if (openBtn) { e.preventDefault(); openCart(); return; }
      var closeBtn = e.target.closest('[data-cart-close]');
      if (closeBtn) { e.preventDefault(); closeCart(); return; }
      if (e.target.closest('[data-cart-close-link]')) { closeCart(); return; }

      var removeBtn = e.target.closest('[data-cart-remove]');
      if (removeBtn) {
        e.preventDefault();
        var line = removeBtn.getAttribute('data-cart-remove');
        changeLine(line, 0);
        return;
      }
      var minus = e.target.closest('[data-qty-minus]');
      if (minus) {
        var wrapM = minus.closest('[data-qty]');
        var drawerItem = minus.closest('.cart-item');
        if (drawerItem && drawerItem.closest('[data-cart-drawer]')) {
          var numEl = $('[data-qty-num]', wrapM);
          var q = parseInt(numEl.textContent, 10) || 1;
          changeLine(drawerItem.getAttribute('data-line'), Math.max(0, q - 1));
        } else {
          var inputM = $('[data-qty-input]', wrapM);
          if (inputM) {
            /* Add-to-cart forms must never go below 1; cart update forms allow 0 (= remove on update) */
            var minM = inputM.closest('form[action*="/cart/add"]') ? 1 : 0;
            inputM.value = Math.max(minM, (parseInt(inputM.value, 10) || 1) - 1);
          }
        }
        return;
      }
      var plus = e.target.closest('[data-qty-plus]');
      if (plus) {
        var wrapP = plus.closest('[data-qty]');
        var drawerItemP = plus.closest('.cart-item');
        if (drawerItemP && drawerItemP.closest('[data-cart-drawer]')) {
          var numElP = $('[data-qty-num]', wrapP);
          var qP = parseInt(numElP.textContent, 10) || 1;
          changeLine(drawerItemP.getAttribute('data-line'), qP + 1);
        } else {
          var inputP = $('[data-qty-input]', wrapP);
          if (inputP) inputP.value = (parseInt(inputP.value, 10) || 0) + 1;
        }
        return;
      }
      var stickyAdd = e.target.closest('[data-sticky-add]');
      if (stickyAdd) {
        e.preventDefault();
        var mainBtn = $('[data-add-to-cart]');
        if (mainBtn && !mainBtn.disabled) {
          mainBtn.closest('form').requestSubmit ? mainBtn.closest('form').requestSubmit() : mainBtn.click();
        }
      }
    });

    on(document, 'submit', function (e) {
      var form = e.target;
      if (form.method && form.method.toLowerCase() === 'post' && form.getAttribute('action') && form.getAttribute('action').indexOf('/cart/add') > -1) {
        e.preventDefault();
        addToCart(form);
        return;
      }
    });

    function addToCart(form) {
      var btn = form.querySelector('[type="submit"]');
      var btnLabel = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.style.opacity = '0.6'; }
      var fd = new FormData(form);
      fetch(CFG.routes.cartAdd + '.js', { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (res) {
          if (!res.ok) {
            var msg = (res.data && (res.data.description || res.data.message)) || S.error || 'Something went wrong';
            toast(msg, true);
            return;
          }
          toast((res.data.title ? res.data.title + ' — ' : '') + (S.added || 'Added to your bag'));
          refreshCart(true);
        })
        .catch(function () { toast(S.error || 'Something went wrong', true); })
        .finally(function () {
          if (btn) { btn.disabled = false; btn.style.opacity = ''; if (btnLabel) btn.innerHTML = btnLabel; }
        });
    }

    function changeLine(line, quantity) {
      fetch(CFG.routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ line: parseInt(line, 10), quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function () { refreshCart(false); })
        .catch(function () { toast(S.error || 'Something went wrong', true); });
    }
    window.__changeCartLine = changeLine;
  }

  /* ---------- countdown timers ---------- */
  function initCountdowns() {
    $$('[data-countdown]').forEach(function (section) {
      var raw = section.getAttribute('data-countdown');
      if (!raw) return;
      var end = new Date(raw.trim().replace(' ', 'T'));
      if (isNaN(end.getTime())) return;
      var dEl = $('[data-cd="days"]', section);
      var hEl = $('[data-cd="hours"]', section);
      var mEl = $('[data-cd="minutes"]', section);
      var sEl = $('[data-cd="seconds"]', section);
      var endedEl = $('[data-cd-ended]', section);
      var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
      function tick() {
        var diff = end.getTime() - Date.now();
        if (diff <= 0) {
          if (dEl) dEl.textContent = '00';
          if (hEl) hEl.textContent = '00';
          if (mEl) mEl.textContent = '00';
          if (sEl) sEl.textContent = '00';
          var timer = $('.countdown__timer', section);
          if (timer) timer.style.display = 'none';
          if (endedEl) endedEl.hidden = false;
          clearInterval(iv);
          return;
        }
        var d = Math.floor(diff / 86400000);
        var h = Math.floor((diff % 86400000) / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        if (dEl) dEl.textContent = pad(d);
        if (hEl) hEl.textContent = pad(h);
        if (mEl) mEl.textContent = pad(m);
        if (sEl) sEl.textContent = pad(s);
      }
      tick();
      var iv = setInterval(tick, 1000);
    });
  }

  /* ---------- scarcity bars ---------- */
  function initScarcity() {
    $$('[data-scarcity]').forEach(function (widget) {
      var inv = parseInt(widget.getAttribute('data-inventory'), 10);
      var threshold = parseInt(widget.getAttribute('data-threshold'), 10) || 5;
      var fill = $('[data-scarcity-fill]', widget);
      var label = $('[data-scarcity-label]', widget);
      if (!fill || isNaN(inv)) return;
      widget.__update = function (newInv) {
        if (typeof newInv === 'number') inv = newInv;
        var pct = clamp(100 - (inv / 25) * 100, 8, 96);
        if (inv <= 0) pct = 100;
        fill.style.width = pct + '%';
        if (label) {
          label.classList.remove('is-healthy', 'is-out');
          if (inv <= 0) { label.textContent = 'Sold out — restocking soon'; label.classList.add('is-out'); }
          else if (inv <= threshold) { label.textContent = 'Only ' + inv + ' left in stock'; }
          else { label.textContent = 'In stock — ships within a week'; label.classList.add('is-healthy'); fill.classList.add('is-healthy'); }
        }
      };
      widget.__update();
    });
  }

  /* ---------- live viewers ---------- */
  function initViewers() {
    if (!CFG.viewers) return;
    $$('[data-viewers]').forEach(function (el) {
      var seed = parseFloat(el.getAttribute('data-seed') || '7');
      var base = 9 + Math.floor(seeded(seed) * 32);
      var numEl = $('[data-viewers-num]', el);
      if (!numEl) return;
      numEl.textContent = base;
      setInterval(function () {
        var delta = Math.random() > 0.5 ? 1 : -1;
        base = clamp(base + delta, 6, 58);
        numEl.textContent = base;
      }, 9000);
    });
  }

  /* ---------- sales toast ---------- */
  function initSalesToast() {
    if (!CFG.salesToast) return;
    var wrap = $('[data-sales-toast]');
    if (!wrap) return;
    var items = $$('[data-toast-item]', wrap).map(function (s) {
      try { return JSON.parse(s.textContent); } catch (e) { return null; }
    }).filter(Boolean);
    var card = $('[data-sales-toast-card]', wrap);
    if (!items.length || !card) return;
    if (store('reloa-toast-dismissed')) return;
    var idx = Math.floor(Math.random() * items.length);
    var shown = 0;
    function show() {
      if (shown >= 6) return;
      var item = items[idx % items.length];
      idx++;
      shown++;
      var nameEl = $('[data-toast-name]', card);
      var cityEl = $('[data-toast-city]', card);
      var prodEl = $('[data-toast-product]', card);
      var timeEl = $('[data-toast-time]', card);
      if (nameEl) nameEl.textContent = item.name;
      if (cityEl) cityEl.textContent = ' from ' + item.city;
      if (prodEl) prodEl.textContent = item.product;
      if (timeEl) timeEl.textContent = item.time;
      if (prodEl) {
        if (item.url) { prodEl.tagName === 'A' && (prodEl.href = item.url); prodEl.style.pointerEvents = 'auto'; }
        else { prodEl.style.pointerEvents = 'none'; }
      }
      card.hidden = false;
      card.classList.remove('is-hiding');
      setTimeout(function () {
        card.classList.add('is-hiding');
        setTimeout(function () { card.hidden = true; }, 500);
      }, 5600);
    }
    setTimeout(show, 5000);
    setInterval(show, 17000);
    on($('[data-toast-close]', card), 'click', function () {
      card.hidden = true;
      store('reloa-toast-dismissed', true);
    });
  }

  /* ---------- exit intent popup ---------- */
  function openExit() {
    var popup = $('[data-exit-popup]');
    if (!popup) return;
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    lockBody();
    store('reloa-exit-shown', true);
  }
  function closeExit() {
    var popup = $('[data-exit-popup]');
    if (popup && popup.classList.contains('is-open')) {
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      unlockBody();
    }
  }
  function initExitPopup() {
    var popup = $('[data-exit-popup]');
    if (!popup) return;

    /* Mark the exit-popup form before it navigates away, so its success
       reload can be told apart from a footer newsletter success reload. */
    var popupForm = $('.exit-popup__form', popup);
    if (popupForm) {
      on(popupForm, 'submit', function () { store('reloa-exit-submitted', '1'); }, true);
    }

    var posted = /[?&]customer_posted=true/.test(window.location.search);
    var justSubmitted = posted && store('reloa-exit-submitted') === '1';

    if (justSubmitted) {
      /* Email was just submitted — swap to the success stage so the visitor
         actually sees their code, and never nag them with the offer again. */
      try { window.sessionStorage.removeItem('reloa-exit-submitted'); } catch (e) {}
      try { window.localStorage.setItem('reloa-exit-done', '1'); } catch (e) {}
      var intro = $('[data-exit-stage="intro"]', popup);
      var success = $('[data-exit-stage="success"]', popup);
      if (intro) intro.hidden = true;
      if (success) success.hidden = false;
      openExit();
    } else {
      var exitDone = false;
      try { exitDone = window.localStorage.getItem('reloa-exit-done') === '1'; } catch (e) {}
      if (!exitDone && !store('reloa-exit-shown')) {
        if (!isTouch) {
          document.addEventListener('mouseout', function (e) {
            if (!e.relatedTarget && e.clientY <= 8 && !store('reloa-exit-shown')) {
              openExit();
            }
          });
        }
        // Mobile exit-intent: trigger on rapid scroll-up after the user has engaged
        // (scrolled past 35% of the page). Fires once per session. This is the
        // closest mobile equivalent to desktop mouseout-to-top exit intent.
        if (isTouch) {
          var lastY = window.scrollY;
          var lastT = Date.now();
          var engaged = false;
          window.addEventListener('scroll', function () {
            var y = window.scrollY;
            var t = Date.now();
            var dt = t - lastT;
            if (dt > 0) {
              var speed = (lastY - y) / dt; // px per ms; positive = scrolling up
              var docH = document.body.scrollHeight - window.innerHeight;
              if (docH > 0 && y > docH * 0.35) engaged = true;
              // Trigger: engaged + scrolling up fast (>2.5px/ms ≈ a flick) + not already shown
              if (engaged && speed > 2.5 && !store('reloa-exit-shown')) {
                openExit();
              }
            }
            lastY = y;
            lastT = t;
          }, { passive: true });
        }
      }
    }
    $$('[data-exit-close]', popup).forEach(function (btn) { on(btn, 'click', closeExit); });
    on(popup, 'click', function (e) { if (e.target === popup) closeExit(); });
  }

  function initCopyCode() {
    on(document, 'click', function (e) {
      var btn = e.target.closest('[data-copy-code]');
      if (!btn) return;
      var codeEl = btn.tagName === 'CODE' ? btn : btn.querySelector('code') || (btn.parentElement && btn.parentElement.querySelector('code'));
      var text = codeEl ? codeEl.textContent : btn.textContent;
      var done = function () {
        var label = btn.matches('button') ? btn : null;
        var old = label ? label.textContent : null;
        if (label) { label.textContent = 'Copied'; label.classList.add('is-copied'); }
        toast('Code ' + text + ' copied — discount auto-applied');
        if (label) setTimeout(function () { label.textContent = old; label.classList.remove('is-copied'); }, 1800);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text.trim()).then(done, done);
      } else {
        var ta = document.createElement('textarea');
        ta.value = text.trim();
        document.body.appendChild(ta);
        ta.select();
        try { document.execCommand('copy'); } catch (err) {}
        ta.remove();
        done();
      }
      // Silently pre-apply the discount to this session so checkout already has it
      try {
        var code = text.trim().toUpperCase();
        if (code && !store('reloa-discount-' + code)) {
          fetch('/discount/' + encodeURIComponent(code), { method: 'GET', credentials: 'same-origin' }).catch(function () {});
          store('reloa-discount-' + code, 1);
        }
      } catch (err) {}
    });
    // Also pre-apply when Apply & Shop is clicked (backup for non-copy users)
    on(document, 'click', function (e) {
      var link = e.target.closest('[data-offer-code] .offer-code__shop');
      if (!link) return;
      var codeEl = link.parentElement && link.parentElement.querySelector('code');
      if (!codeEl) return;
      try {
        var code = codeEl.textContent.trim().toUpperCase();
        if (code) {
          fetch('/discount/' + encodeURIComponent(code), { method: 'GET', credentials: 'same-origin' }).catch(function () {});
        }
      } catch (err) {}
    });
  }

  /* ---------- recently viewed products (PDP) ----------
     Tracks viewed product IDs in localStorage and renders the last 8 as a
     horizontal carousel on the PDP. The current product is excluded. */
  function initRecentlyViewed() {
    var section = $('[data-recently-viewed]');
    if (!section) return;
    var track = $('[data-recently-viewed-track]', section);
    if (!track) return;
    var currentId = section.dataset.productId || document.body.dataset.productId;
    var ids = [];
    try { ids = JSON.parse(window.localStorage.getItem('reloa-recently-viewed') || '[]'); } catch (e) { ids = []; }
    // Remove current product from list
    ids = ids.filter(function (id) { return String(id) !== String(currentId); });
    if (!ids.length) { section.hidden = true; return; }
    // Take last 8, reverse so most recent is first
    var recent = ids.slice(-8).reverse();
    // Render via fetch — get product cards from /products/handle?view=card
    var fetched = 0;
    recent.forEach(function (id) {
      // We need the handle, not ID. Store handles alongside IDs.
      // Fallback: fetch product JSON by handle stored in a parallel array.
    });
    // Simpler approach: store handles in localStorage, fetch each product page's card snippet
    var handles = [];
    try { handles = JSON.parse(window.localStorage.getItem('reloa-recently-handles') || '[]'); } catch (e) { handles = []; }
    var recentHandles = handles.slice(-8).reverse();
    var currentHandle = section.dataset.productHandle || document.body.dataset.productHandle;
    if (currentHandle) {
      recentHandles = recentHandles.filter(function (h) { return h !== currentHandle; });
    }
    if (!recentHandles.length) { section.hidden = true; return; }
    section.hidden = false;
    recentHandles.slice(0, 8).forEach(function (handle) {
      fetch('/products/' + handle + '?view=card', { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var div = document.createElement('div');
          div.innerHTML = html.trim();
          var card = div.firstElementChild;
          if (card) {
            track.appendChild(card);
            // Re-init tilt + wishlist for the new card
            if (card.hasAttribute('data-tilt') && !motionOff) { on(card, 'mousemove', function (e) { /* tilt handler inits lazily */ }); }
          }
        })
        .catch(function () {});
    });
  }

  function trackRecentlyViewed() {
    // Called on PDP load. Records current product handle.
    var section = $('[data-recently-viewed]');
    if (!section) return;
    var handle = section.dataset.productHandle;
    var id = section.dataset.productId;
    if (!handle || !id) return;
    try {
      var ids = JSON.parse(window.localStorage.getItem('reloa-recently-viewed') || '[]');
      var handles = JSON.parse(window.localStorage.getItem('reloa-recently-handles') || '[]');
      // Remove if already present
      ids = ids.filter(function (x) { return String(x) !== String(id); });
      handles = handles.filter(function (x) { return x !== handle; });
      // Append (keep last 16)
      ids.push(id);
      handles.push(handle);
      if (ids.length > 16) ids = ids.slice(-16);
      if (handles.length > 16) handles = handles.slice(-16);
      window.localStorage.setItem('reloa-recently-viewed', JSON.stringify(ids));
      window.localStorage.setItem('reloa-recently-handles', JSON.stringify(handles));
    } catch (e) {}
  }

  /* ---------- delivery date estimator (PDP) ----------
     Shows an estimated delivery date based on current date + dispatch lead time.
     Purely indicative — not a real pincode lookup. */
  function initDeliveryEstimator() {
    var el = $('[data-delivery-estimator]');
    if (!el) return;
    var dateEl = $('[data-delivery-date]', el);
    if (!dateEl) return;
    // Dispatch: 1 week lead time (ships within 7 days) + 2-4 days delivery.
    // Show the upper bound (4 days from dispatch).
    var now = new Date();
    var dispatchDays = 7;
    var deliveryDays = 4;
    var eta = new Date(now.getTime() + ((dispatchDays + deliveryDays) * 24 * 60 * 60 * 1000));
    // Skip weekends for display
    while (eta.getDay() === 0 || eta.getDay() === 6) {
      eta = new Date(eta.getTime() + (24 * 60 * 60 * 1000));
    }
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    dateEl.textContent = days[eta.getDay()] + ', ' + eta.getDate() + ' ' + months[eta.getMonth()];
    el.hidden = false;
  }

  /* ---------- wishlist count badge in header ---------- */
  function initWishlistCount() {
    var badges = $$('.header__wishlist-count');
    if (!badges.length) return;
    function update() {
      var count = 0;
      try { count = JSON.parse(window.localStorage.getItem('reloa-wishlist') || '[]').length; } catch (e) {}
      badges.forEach(function (b) {
        b.textContent = count;
        b.hidden = count === 0;
      });
    }
    update();
    // Listen for wishlist changes
    window.addEventListener('storage', update);
    // Periodic check (covers non-storage events)
    setInterval(update, 2000);
  }

  /* ---------- newsletter returning-subscriber state ----------
     If visitor has already subscribed (flag in localStorage + cookie), swap the
     homepage newsletter form for a 'welcome back' block that shows the code.
     The flag is set whenever Shopify redirects with ?customer_posted=true
     (the native newsletter form-success signal). Dual storage (localStorage +
     cookie) ensures the flag survives even when one storage type is blocked. */
  function setCookie(name, value, days) {
    try {
      var d = new Date();
      d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
      document.cookie = name + '=' + value + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
    } catch (e) {}
  }
  function getCookie(name) {
    try {
      var n = name + '=';
      var parts = document.cookie.split(';');
      for (var i = 0; i < parts.length; i++) {
        var c = parts[i].trim();
        if (c.indexOf(n) === 0) return c.substring(n.length);
      }
    } catch (e) {}
    return '';
  }
  function initNewsletterState() {
    try {
      if (/[?&]customer_posted=true/.test(window.location.search)) {
        try { window.localStorage.setItem('reloa-subscribed', '1'); } catch (e) {}
        setCookie('reloa-subscribed', '1', 365);
        return; // success state is rendered server-side; don't hide it
      }
    } catch (e) {}
    var already = false;
    try { already = window.localStorage.getItem('reloa-subscribed') === '1'; } catch (e) {}
    if (!already && getCookie('reloa-subscribed') === '1') already = true;
    if (!already) return;
    var form = document.querySelector('[data-newsletter-form]');
    var wb = document.querySelector('[data-welcomeback]');
    if (form && wb) {
      form.style.display = 'none';
      wb.hidden = false;
    }
  }

  /* ---------- wishlist ---------- */
  function getWishlist() {
    try { return JSON.parse(window.localStorage.getItem('reloa-wishlist') || '[]'); } catch (e) { return []; }
  }
  function initWishlist() {
    var list = getWishlist();
    $$('[data-wishlist]').forEach(function (btn) {
      var id = btn.getAttribute('data-wishlist');
      if (list.indexOf(id) > -1) btn.classList.add('is-active');
      on(btn, 'click', function (e) {
        e.preventDefault();
        var current = getWishlist();
        var pos = current.indexOf(id);
        if (pos > -1) {
          current.splice(pos, 1);
          btn.classList.remove('is-active');
          toast('Removed from your saves');
        } else {
          current.push(id);
          btn.classList.add('is-active');
          toast('Saved — we\u2019ll keep it safe for you');
        }
        try { window.localStorage.setItem('reloa-wishlist', JSON.stringify(current)); } catch (err) {}
      });
    });
  }

  /* ---------- PDP: gallery ---------- */
  function initGallery() {
    var gallery = $('[data-gallery]');
    if (!gallery) return;
    $$('[data-thumb]', gallery).forEach(function (thumb) {
      on(thumb, 'click', function () {
        var id = thumb.getAttribute('data-media-id');
        $$('[data-thumb]', gallery).forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        $$('[data-media]', gallery).forEach(function (m) {
          m.classList.toggle('is-active', m.getAttribute('data-media-id') === id);
        });
      });
    });
  }

  /* ---------- PDP: variant picker ---------- */
  function initVariantPicker() {
    var picker = $('[data-variant-picker]');
    if (!picker) return;
    var jsonEl = $('[data-variants]');
    if (!jsonEl) return;
    var variants;
    try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    if (!variants || !variants.length) return;

    var productForm = picker.closest('.pdp__info').querySelector('form[action*="/cart/add"]') || $('form[action*="/cart/add"]');
    var idInput = $('[data-variant-id]');
    var addBtn = $('[data-add-to-cart]');
    var addLabel = $('[data-add-label]');
    var priceWrap = $('[data-price-wrapper]');
    var stickyPrice = $('[data-sticky-price]');
    var stickyImg = $('[data-sticky-img]');
    var scarcity = $('[data-scarcity]');

    function selectedOptions() {
      var groups = $$('.variant-option', picker);
      return groups.map(function (group) {
        var checked = $('input:checked', group);
        return checked ? checked.value : null;
      });
    }

    function findVariant(selection) {
      var exact = variants.filter(function (v) {
        return v.options.every(function (opt, i) { return opt === selection[i]; });
      });
      if (exact.length) return exact[0];
      var partial = variants.filter(function (v) {
        for (var i = 0; i < selection.length; i++) {
          if (selection[i] && v.options[i] !== selection[i]) return false;
        }
        return true;
      });
      var available = partial.filter(function (v) { return v.available; });
      return available[0] || partial[0] || null;
    }

    function renderPrice(variant) {
      if (!priceWrap || !variant) return;
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      var pct = onSale ? Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100) : 0;
      priceWrap.innerHTML =
        '<div class="price' + (onSale ? ' price--on-sale' : '') + (variant.available ? '' : ' price--sold-out') + '">' +
        (variant.available
          ? '<span class="price__current">' + formatMoney(variant.price) + '</span>'
          : '<span class="price__current">Sold out</span>') +
        (onSale ? '<s class="price__compare">' + formatMoney(variant.compare_at_price) + '</s>' +
          '<span class="price__badge">-' + pct + '%</span>' : '') +
        '</div>';
    }

    function markUnavailable(selection) {
      var groups = $$('.variant-option', picker);
      groups.forEach(function (group, gi) {
        var labels = $$('label', group);
        labels.forEach(function (label) {
          var value = label.getAttribute('for') && $('#' + label.getAttribute('for'), group) ? $('#' + label.getAttribute('for'), group).value : label.textContent.trim();
          var test = selection.slice();
          test[gi] = value;
          var match = variants.filter(function (v) {
            return test.every(function (opt, i) { return !opt || v.options[i] === opt; }) && v.available;
          });
          label.classList.toggle('is-unavailable', match.length === 0);
        });
      });
    }

    function update(selectedFromVariant) {
      var selection = selectedOptions();
      var variant = selectedFromVariant || findVariant(selection);
      if (!variant) return;

      /* sync radio states to the resolved variant (handles fallback picks) */
      var groups = $$('.variant-option', picker);
      groups.forEach(function (group, gi) {
        var val = variant.options[gi];
        if (val == null) return;
        $$('input', group).forEach(function (input) {
          if (input.value === val) input.checked = true;
        });
        var em = $('[data-selected-value]', group);
        if (em) em.textContent = val;
      });

      if (idInput) idInput.value = variant.id;
      renderPrice(variant);
      markUnavailable(selectedOptions());
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);

      if (addBtn) {
        addBtn.disabled = !variant.available;
        if (addLabel) addLabel.textContent = variant.available
          ? 'Add to bag — ' + formatMoney(variant.price)
          : 'Sold out';
      }

      if (variant.featured_media && variant.featured_media.id) {
        var mediaId = String(variant.featured_media.id);
        var target = $('[data-media][data-media-id="' + mediaId + '"]');
        if (target) {
          $$('[data-media]').forEach(function (m) { m.classList.remove('is-active'); });
          target.classList.add('is-active');
          var thumb = $('[data-thumb][data-media-id="' + mediaId + '"]');
          if (thumb) {
            $$('[data-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
            thumb.classList.add('is-active');
          }
        }
        if (stickyImg && variant.featured_media.preview_image) {
          stickyImg.src = variant.featured_media.preview_image.src;
        }
      }

      if (scarcity && typeof scarcity.__update === 'function' && typeof variant.inventory_quantity === 'number') {
        scarcity.__update(variant.inventory_quantity);
      }

      try {
        var url = new URL(window.location);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}
    }

    on(picker, 'change', function (e) {
      if (e.target.matches('[data-variant-radio]')) update();
    });
    markUnavailable(selectedOptions());
  }

  /* ---------- sticky add-to-cart ---------- */
  function initStickyAtc() {
    if (!CFG.stickyAtc) return;
    var bar = $('[data-sticky-atc]');
    var mainBtn = $('[data-add-to-cart]');
    if (!bar || !mainBtn) return;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      }, { threshold: 0 });
      io.observe(mainBtn);
    }
  }

  /* ---------- product recommendations ---------- */
  function initRecommendations() {
    var holder = $('[data-recommendations]');
    if (!holder || !holder.getAttribute('data-url')) return;
    fetch(holder.getAttribute('data-url'))
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim().length) {
          holder.innerHTML = fresh.innerHTML;
          initReveals();
          initTilt();
          initMagnetic();
        }
      })
      .catch(function () {});
  }

  /* ---------- lookbook drag ---------- */
  function initLookbook() {
    var track = $('[data-lookbook]');
    if (!track) return;
    var isDown = false, startX = 0, startScroll = 0, moved = false;
    track.addEventListener('pointerdown', function (e) {
      isDown = true; moved = false;
      startX = e.clientX;
      startScroll = track.scrollLeft;
      track.classList.add('is-dragging');
    });
    window.addEventListener('pointermove', function (e) {
      if (!isDown) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 6) moved = true;
      track.scrollLeft = startScroll - dx;
    });
    window.addEventListener('pointerup', function () {
      isDown = false;
      track.classList.remove('is-dragging');
    });
    $$('a', track).forEach(function (a) {
      a.addEventListener('click', function (e) {
        if (moved) { e.preventDefault(); moved = false; }
      });
    });
  }

  /* ---------- testimonials carousel ---------- */
  function initTestimonials() {
    $$('[data-testi]').forEach(function (root) {
      var slides = $$('[data-testi-slide]', root);
      var dots = $$('[data-testi-dot]', root);
      if (slides.length < 2) return;
      var i = 0, timer = null;
      var interval = (parseInt(root.getAttribute('data-testi-interval'), 10) || 6) * 1000;
      function go(n) {
        slides[i].classList.remove('is-active');
        if (dots[i]) dots[i].classList.remove('is-active');
        i = (n + slides.length) % slides.length;
        slides[i].classList.add('is-active');
        if (dots[i]) dots[i].classList.add('is-active');
      }
      function play() { timer = setInterval(function () { go(i + 1); }, interval); }
      function stop() { clearInterval(timer); }
      on($('[data-testi-prev]', root), 'click', function () { stop(); go(i - 1); play(); });
      on($('[data-testi-next]', root), 'click', function () { stop(); go(i + 1); play(); });
      dots.forEach(function (dot) {
        on(dot, 'click', function () { stop(); go(parseInt(dot.getAttribute('data-testi-dot'), 10)); play(); });
      });
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', play);
      play();
    });
  }

  /* ---------- sort select ---------- */
  function initSort() {
    var sel = $('[data-sort-select]');
    on(sel, 'change', function () {
      var form = sel.closest('form');
      if (form) form.submit();
    });
  }

  /* ---------- auth panel toggle ---------- */
  function initAuthToggle() {
    var toggles = $$('[data-recover-toggle]');
    if (!toggles.length) return;
    toggles.forEach(function (btn) {
      on(btn, 'click', function () {
        var login = $('[data-auth-panel="login"]');
        var recover = $('[data-auth-panel="recover"]');
        if (!login || !recover) return;
        var showRecover = !recover.hidden === false;
        if (recover.hidden) {
          login.hidden = true;
          recover.hidden = false;
          var input = $('input', recover);
          if (input) setTimeout(function () { input.focus(); }, 80);
        } else {
          recover.hidden = true;
          login.hidden = false;
        }
      });
    });
    /* auto-show recover panel if the URL was redirected from a reset */
    if (window.location.hash === '#recover') {
      var login2 = $('[data-auth-panel="login"]');
      var recover2 = $('[data-auth-panel="recover"]');
      if (login2 && recover2) { login2.hidden = true; recover2.hidden = false; }
    }
  }

  /* ---------- WhatsApp OTP verification ---------- */
  function initWaVerify() {
    $$('[data-wa-verify]').forEach(function (widget) {
      var endpoint = (CFG.waEndpoint || '').trim();
      var phoneInput = $('[data-wa-phone]', widget);
      var codeInput = $('[data-wa-code]', widget);
      var sendBtn = $('[data-wa-send]', widget);
      var checkBtn = $('[data-wa-check]', widget);
      var stepPhone = $('[data-wa-step="phone"]', widget);
      var stepCode = $('[data-wa-step="code"]', widget);
      var msg = $('[data-wa-msg]', widget);
      var badge = $('[data-wa-badge]', widget);
      var note = $('[data-wa-note]', widget);

      function setMsg(text, kind) {
        if (!msg) return;
        msg.textContent = text || '';
        msg.className = 'wa-verify__msg' + (kind ? ' is-' + kind : '');
      }
      function markVerified(phone) {
        widget.classList.add('is-verified');
        if (badge) badge.hidden = false;
        if (stepPhone) stepPhone.hidden = true;
        if (stepCode) stepCode.hidden = true;
        if (phoneInput && phone) phoneInput.value = phone;
        setMsg(S.waVerified || 'WhatsApp verified', 'success');
        try { window.localStorage.setItem('reloa-wa', phone); } catch (e) {}
      }

      var saved = null;
      try { saved = window.localStorage.getItem('reloa-wa'); } catch (e) {}
      if (saved) markVerified(saved);

      if (!endpoint || !sendBtn) {
        /* No OTP service configured — the number is still captured and
           validated on submit. Verification can be switched on later. */
        if (checkBtn) checkBtn.disabled = true;
        return;
      }

      function normalize(raw) {
        var digits = (raw || '').replace(/\D/g, '');
        if (digits.length === 10) digits = '91' + digits;
        return digits;
      }

      on(sendBtn, 'click', function () {
        var phone = normalize(phoneInput && phoneInput.value);
        if (phone.length < 10) { setMsg('Enter a valid WhatsApp number', 'error'); return; }
        sendBtn.disabled = true;
        sendBtn.textContent = 'Sending…';
        setMsg('');
        fetch(endpoint.replace(/\/$/, '') + '/send-otp', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ phone: phone })
        })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (data && data.ok) {
              widget.__phone = phone;
              if (stepPhone) stepPhone.hidden = true;
              if (stepCode) stepCode.hidden = false;
              setMsg(S.waSent || 'Code sent to your WhatsApp', 'success');
              if (codeInput) codeInput.focus();
            } else {
              setMsg((data && data.error) || S.waFail || 'Verification unavailable right now', 'error');
            }
          })
          .catch(function () { setMsg(S.waFail || 'Verification unavailable right now', 'error'); })
          .finally(function () {
            sendBtn.disabled = false;
            sendBtn.textContent = S.waVerifySend || 'Send code';
          });
      });

      on(checkBtn, 'click', function () {
        var code = (codeInput && codeInput.value || '').replace(/\D/g, '');
        if (code.length !== 6) { setMsg('Enter the 6-digit code', 'error'); return; }
        checkBtn.disabled = true;
        checkBtn.textContent = '…';
        fetch(endpoint.replace(/\/$/, '') + '/verify-otp', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ phone: widget.__phone, code: code })
        })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (data && data.ok) {
              markVerified(widget.__phone || '');
            } else {
              setMsg(S.waInvalid || 'Invalid code — try again', 'error');
            }
          })
          .catch(function () { setMsg(S.waFail || 'Verification unavailable right now', 'error'); })
          .finally(function () {
            checkBtn.disabled = false;
            checkBtn.textContent = S.waVerifyVerify || 'Verify';
          });
      });

      on(codeInput, 'keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); checkBtn && checkBtn.click(); } });
      on(phoneInput, 'keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); sendBtn && sendBtn.click(); } });
    });
  }

  /* ---------- required phone guard ---------- */
  function initRegisterGuard() {
    $$('form').forEach(function (form) {
      var phone = $('[data-required-phone]', form);
      if (!phone) return;
      /* capture phase so we can block the native submit */
      form.addEventListener('submit', function (e) {
        var digits = (phone.value || '').replace(/\D/g, '');
        if (digits.length >= 10) {
          phone.value = digits;
          phone.classList.remove('is-error');
          return;
        }
        e.preventDefault();
        phone.classList.add('is-error');
        var msg = $('.wa-verify__msg', form) || $('[data-phone-msg]', form);
        if (msg) {
          msg.textContent = S.phoneNeed || 'Please add your WhatsApp number — we send order updates & member perks there';
          msg.className = 'wa-verify__msg is-error';
        }
        try { phone.focus(); } catch (err) {}
      }, true);
    });
  }

  /* ---------- mega menu viewport clamp ---------- */
  function initMegaClamp() {
    $$('.has-mega').forEach(function (li) {
      var panel = $('.header__dropdown--mega', li);
      if (!panel) return;
      on(li, 'mouseenter', function () {
        panel.style.marginLeft = '0px';
        /* make visible (but transparent) so we can measure */
        var prev = panel.style.visibility;
        panel.style.visibility = 'hidden';
        panel.style.display = 'block';
        var rect = panel.getBoundingClientRect();
        panel.style.display = '';
        panel.style.visibility = prev;
        var pad = 16;
        var vw = document.documentElement.clientWidth;
        if (rect.left < pad) {
          panel.style.marginLeft = (pad - rect.left) + 'px';
        } else if (rect.right > vw - pad) {
          panel.style.marginLeft = (vw - pad - rect.right) + 'px';
        }
      });
    });
  }

  /* ---------- boot ---------- */
  function initAll() {
    initCursor();
    initReveals();
    initTilt();
    initMagnetic();
    initHeroParallax();
    initScrollParallax();
    initRotator();
    initCountUps();
    initAnnouncement();
    initHeader();
    initDrawers();
    initCartInteractions();
    initCountdowns();
    initScarcity();
    initViewers();
    initSalesToast();
    initExitPopup();
    initCopyCode();
    initNewsletterState();
    initDeliveryEstimator();
    initWishlist();
    initWishlistCount();
    initRecentlyViewed();
    trackRecentlyViewed();
    initGallery();
    initVariantPicker();
    initStickyAtc();
    initRecommendations();
    initLookbook();
    initTestimonials();
    initSort();
    initAuthToggle();
    initWaVerify();
    initMegaClamp();
    initRegisterGuard();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
